var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import IVueDialog from "@/interface/IVueDialog";
import CommonService from "@/api/CommonService";
var DialogBindWechat = (function (_super) {
    __extends(DialogBindWechat, _super);
    function DialogBindWechat() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.qrcodeImg = '';
        _this.ticket = '';
        _this.loading = false;
        _this.isExpired = false;
        _this.isScan = false;
        _this.timerDuration = 2000;
        _this.timerResult = null;
        _this.timerQrcode = null;
        return _this;
    }
    DialogBindWechat.prototype.created = function () {
        this.commonService = CommonService.getInstance();
        this.initQrcode();
    };
    DialogBindWechat.prototype.mounted = function () {
    };
    DialogBindWechat.prototype.beforeDestroy = function () {
        this.clearTimer();
    };
    DialogBindWechat.prototype.clearTimer = function () {
        this.clearResultTimer();
        this.clearQrcodeTimer();
    };
    DialogBindWechat.prototype.clearResultTimer = function () {
        clearInterval(this.timerResult);
    };
    DialogBindWechat.prototype.clearQrcodeTimer = function () {
        clearInterval(this.timerQrcode);
    };
    DialogBindWechat.prototype.getQrcodeStatus = function () {
        var _this = this;
        this.clearQrcodeTimer();
        this.commonService.getTemporaryTokenQrcodeStatus({ ticket: this.ticket }).then(function (res) {
            var _a = res.data.data, is_expired = _a.is_expired, is_used = _a.is_used;
            if (is_used) {
                _this.clearTimer();
                _this.isScan = true;
                return;
            }
            if (is_expired) {
                _this.clearTimer();
                _this.isExpired = true;
                return;
            }
            _this.timerQrcode = setTimeout(function () {
                _this.getQrcodeStatus();
            }, _this.timerDuration);
        });
    };
    DialogBindWechat.prototype.initQrcode = function () {
        var _this = this;
        this.clearQrcodeTimer();
        this.isScan = false;
        this.loading = true;
        this.commonService.getTemporaryTokenLoginQrcode({ business_id: this.business_id }).then(function (res) {
            _this.isExpired = false;
            var _a = res.data.data, url = _a.url, ticket = _a.ticket;
            _this.qrcodeImg = url;
            _this.ticket = ticket;
            _this.getQrcodeStatus();
        }).finally(function () {
            _this.loading = false;
        });
    };
    DialogBindWechat = __decorate([
        Component
    ], DialogBindWechat);
    return DialogBindWechat;
}(IVueDialog));
export default DialogBindWechat;
